module.exports = __webpack_public_path__ + "media/images/emblems/Fischenthal-blazon-2339ca1a16fa03e04f4ca640b56a4f89.svg";